import { Button, Modal, PageTitle } from "../../../../../../../../components";

const ResetModal = ({ isOpen, onClose, onConfirm, title = "" }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} width="max-w-xl">
      <div className="p-4">
        <PageTitle title={"Are you sure you want to proceed?"} icon={"info"} tag="p" />

        <div className="flex justify-end gap-3 mt-6">
          <Button title={"No"} variant="outlined" onClick={onClose} />
          <Button title={"Yes"} onClick={onConfirm} />
        </div>
      </div>
    </Modal>
  );
};

export default ResetModal;
